export const VIDEO_ACCEPT_TYPES = 'video/mp4,video/quicktime'
export const VIDEO_FORMATS = 'MP4'
export const IMAGE_ACCEPT_TYPES = 'image/jpeg,image/png,image/heic,image/heif'
export const IMAGE_FORMATS = 'JPG, PNG'
export const DOCUMENT_ACCEPT_TYPES = `${IMAGE_ACCEPT_TYPES},application/pdf`
export const DOCUMENT_FORMATS = 'JPG, PNG, PDF'
